import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getProjectInvitation } from '@/features/projects/project-invitation/api/get-project-invitation';
import { GetProjectInvitationInput } from '@/features/projects/project-invitation/api/get-project-invitation';

const getProjectInvitationQueryKey = (invitationToken: string) => [
  'projectInvitation',
  { invitationToken },
];

type Props = GetProjectInvitationInput &
  Omit<
    UseQueryOptions<Awaited<ReturnType<typeof getProjectInvitation>>>,
    'queryKey' | 'queryFn'
  >;

export const useGetProjectInvitation = ({
  invitationToken,
  ...props
}: Props) => {
  return useQuery({
    ...props,
    queryKey: getProjectInvitationQueryKey(invitationToken),
    queryFn: () => getProjectInvitation({ invitationToken }),
  });
};
